import { usePermission } from '@1823-partners/core';

/*
 * The server gate behind every pricing write. Taken from the @require_permission decorators on
 * pam-master's pricing_server: /save-pricing, /save-brokers, /save-frequency,
 * /save-mom-pricing-notes and the three delete routes all require this one permission.
 *
 * Named here so a Save button can say why it is disabled instead of letting the click come back as
 * a 403 toast. The server remains the enforcer; this is only a hint, moved earlier.
 */
export const PRICING_WRITE = 'pricing.overrides:write';

/** The role that carries PRICING_WRITE, per pam-master's bootstrap_seed. Used in the message. */
export const PRICING_WRITE_ROLE = 'pricing_editor';

export const NO_PRICING_WRITE_MESSAGE =
  `You do not have permission to save pricing changes — request the ${PRICING_WRITE_ROLE} role from the permissions menu`;

/**
 * Whether the caller may perform a pricing write, for disabling a control before it is clicked.
 *
 * DELIBERATELY PERMISSIVE. An unmounted permission center, a still-loading fetch or a failed one
 * all return true. Disabling on absent information would lock out someone who actually holds the
 * grant, which is worse than the 403 this is meant to pre-empt -- and it would look deliberate, so
 * nobody would think to re-check it. That is core's `allowWhileUnknown: true`.
 */
export const useCanWritePricing = () => usePermission(PRICING_WRITE, { allowWhileUnknown: true });
